var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.breadcrumbs
  }, [_c('div', [_vm.backRoute ? _c('RouterLink', {
    attrs: {
      "to": {
        name: _vm.backRoute,
        params: _vm.backRouteParams
      }
    }
  }, [_c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.backButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "gray"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    class: _vm.$style.breadcrumbsItems
  }, [_vm._l(_vm.items, function (item, index) {
    var _class, _class2;
    return [_c('div', {
      key: item.label,
      staticStyle: {
        "display": "contents"
      }
    }, [item.routeName ? _c('RouterLink', {
      attrs: {
        "to": {
          name: item.routeName,
          params: Object.assign({}, item.routeParams)
        }
      }
    }, [_c('p', {
      staticClass: "p2 color-darkest-gray",
      class: (_class = {}, _class[_vm.$style.selectedBreadcrumb] = item.selected, _class)
    }, [_vm._v(" " + _vm._s(item.label.toUpperCase()) + " ")])]) : _c('p', {
      staticClass: "p2 color-darkest-gray",
      class: (_class2 = {}, _class2[_vm.$style.selectedBreadcrumb] = item.selected, _class2)
    }, [_vm._v(" " + _vm._s(item.label.toUpperCase()) + " ")]), index < _vm.items.length - 1 ? _c('BaseIcon', {
      staticClass: "color-gray",
      class: _vm.$style.rightArrow,
      attrs: {
        "name": "chevron-right"
      }
    }) : _vm._e()], 1)];
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }